import { Stack } from "@mui/material";
import { CoworkerSchema } from "../../../api/schemas/responses/users";
import MainAvatar from "../../../components/MainAvatar";



export interface ActiveTableEditorsProps {
    editors: CoworkerSchema[];
}


const ActiveTableEditors = (props: ActiveTableEditorsProps) => {
    if (!props.editors || props.editors.length === 0) return null;
    return (
        <Stack direction="row" spacing={2}>
            {
                props.editors.map((editor, index) => (
                    <MainAvatar key={editor.id} user={editor} />
                ))
            }
        </Stack>
    );
};

export default ActiveTableEditors;
